import styled from 'styled-components';

export const SignupEmailSection = styled.div`
    flex: 1 1 auto;
    padding: calc(100vh*(51/812)) calc(100vw*(20/375)) calc(100vh*(60/812)) calc(100vw*(20/375));
    height: 100%;
`;

export const TitleArea = styled.div`
    margin-top: calc(100vh * ( 54 / 812));
    font-size: 20px;
    font-weight: 700;
    line-height: calc(100vw * (29 / 375));
    white-space: pre-wrap;
    margin-bottom: calc(100vh * ( 35 / 812));
`

export const FieldWrapper = styled.div``;
export const EmailWrapper = styled.div`
    display: flex;
`;
export const EmailInputWrapper =styled.div`
    flex : 1 1 auto;
    width: 100%;
    padding-right: calc(100vw * (13 / 375));
`;

export const EmailInputBlock = styled.div`
    position: relative;
    display: inline-block;  
`;
export const EmailCodeWrapper = styled.div`
    margin-bottom : calc(100vw * (12 / 375));
`;
export const InputStyle = styled.input`
    
    border: 1px solid #D5D5D5;
    border-radius: calc(100vw * (5 / 375));
    width: 100%;
    
    padding: calc(100vw * (11 / 375));
    &:focus {
        border: 1px solid #FFCF19;
    }
    &::placeholder {
        font-size: calc(100vw * (14 / 375));
        color: #C6C6C6;
    }
    &.error_active {
        border 1px solid #de0000;
    }
`;

export const DeleteButton = styled.button`
    position: absolute;
    top: 50%;
    right: 5%;
    height: calc(100vw * (18 / 375));
    transform: translate(0, -50%);
`;

export const DeleteIcon = styled.img`
    width: calc(100vw * (18 / 375));
`;
export const ResendEmailCodeWrapper = styled.div`
    text-align: center;
`;
export const ResendEmailCodeBtn = styled.div`
    display: inline-block;
    color: #707070;
    font-size: calc(100vw * (12 / 375));
    line-height: calc(100vw * (17 / 375));
    text-align: center;
    text-decoration: underline; 
`;

export const ValidateBtn = styled.div`
    flex: 0 1 auto;
    display: inline-block;
    padding: calc(100vw * (10 / 375)) calc(100vw * (18 / 375));
    background: #FFCF19;
    border-radius: 5px;
    color: #121212;
    font-weight: bold;
    font-size: calc(100vw * (16 / 375));
    line-height: calc(100vw * (23 / 375));
    min-width: calc(100vw * (96 / 375)) ;
`;
export const ErrorBlock = styled.div`
    margin-top: calc(100vw * (4 / 375));
    min-height: 19px;
`;

export const ErrorIcon = styled.img`
    width: calc(100vw * (12 / 375));
    margin-right: calc(100vw * (4.5 / 375));
`;

export const ErrorMessage = styled.p`
    display: inline-block;
    font-size: calc(100vw * (10 / 375));
    color: #de0000;
    
`;

const LoadingIconWrapper = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    width:calc(100vw*(40/375));
    height:calc(100vw*(40/375));
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 10;
`;